import { IPersonalAccidentsInsurable } from '@webapp/risks';
import { IBasePolicy, PolicyTabNames } from '../../interfaces/policies.interface';
import { InsurableMapper } from '../insurableMapper';

export class PersonalAccidentsInsurableMapper implements InsurableMapper<IPersonalAccidentsInsurable> {
  map(insurable: unknown): IPersonalAccidentsInsurable {
    return insurable as IPersonalAccidentsInsurable;
  }

  getTitle(policy: IBasePolicy, insurable: IPersonalAccidentsInsurable): string {
    return `#${policy.internalNumber} - ${insurable?.description || policy.title || ''}`;
  }

  getTabs(): string[] {
    return [PolicyTabNames.INFO, PolicyTabNames.INSURED];
  }
}
